<template>
  <div class="mb-8">
    <h3 class="border-bottom pb-4">
      {{ data.title ? data.title : "Parameters" }}
    </h3>
    <v-row v-for="(item, index) in data.items" :key="index" class="mx-0">
      <v-col cols="12" class="border-bottom pl-0 mb-2">
        <div class="mb-3 mainS--text">
          <v-chip label class="mr-4 item-name">{{ item.name }}</v-chip>
          <span class="mr-2 item-type">{{ item.type }}</span>
          <span
            :class="{
              'mx-2 item-required': item.required === true,
              'mx-2 item-optional': item.required !== true,
            }"
            >{{
              item.required_text
                ? item.required_text
                : item.required === true
                ? "REQUIRED"
                : "OPTIONAL"
            }}</span
          >
        </div>
        <div v-html="item.description" class="mainS--text"></div>

        <div v-if="item.items">
          <AttributesChildTemplate :data="item.items" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AttributesChildTemplate from "./AttributesChildTemplate";

export default {
  name: "AttributesTemplate",
  components: { AttributesChildTemplate },
  props: {
    data: Object,
  },
};
</script>

<style lang="scss" scoped>
.border-bottom {
  border-bottom: 1px solid rgba(136, 151, 162, 0.5) !important;
}

.item-name {
  @extend .gothamRegular;
  color: $clay !important;
  font-size: 16px;
}

.item-type {
  @extend .gothamRegular;
  font-size: 16px;
}

.item-required {
  @extend .gothamRegular;
  color: $danger;
  font-size: 14px;
  font-weight: 600 !important;
}

.item-optional {
  @extend .gothamRegular;
  color: $forestGreen;
  font-size: 14px;
  font-weight: 600 !important;
}
</style>
